<template>
    <app-layout>
        <template #header>
            <div class="relative">
                <div class="absolute top-0 right-0">
                    <inertia-link
                        class="bg-gray-300 hover:bg-gray-500 text-black py-1 px-3 mx-3 rounded my-0"
                        :href="route('pix.index')">
                        <i class="fas fa-arrow-left mx-1"></i> Voltar
                    </inertia-link>
                    <button @click="save()"
                            class="bg-green-500 text-sm hover:bg-green-700 text-white text-base font-bold my-0 -mt-10 py-3 px-6 rounded">
                        <i class="fas fa-save mx-1"></i>
                        Salvar
                    </button>
                </div>
                <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                    Chave Pix
                </h2>
            </div>
        </template>
        <div>
            <div class="max-w-7xl mx-auto py-10 sm:px-6 lg:px-8">
                <flash :timeout="5000"/>

                <template>
                    <jet-form-section>
                        <template #title>
                            Cadastre sua chave Pix
                        </template>

                        <template #description>
                            Você pode cadastrar sua chave {{customer_type}}, E-mail, Celular ou Aleatória
                        </template>

                        <template #form>
                            <div class="col-span-6 sm:col-span-6">
                                <div class="col-span-6">
                                    <div class="grid grid-cols-1 gap-4">
                                        <jet-label class="col-span-6" value="Tipo de Chave"/>
                                    </div>
                                    <div class="grid grid-cols-6 gap-4 mb-2">
                                        <div class="grid col-span-2">
                                            <jet-auto-complete
                                                :key="'pixType'"
                                                class="mt-1 w-full col-span-2"
                                                v-model="form.newKey.key_type"
                                                :options-list="keyTypeList"/>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-span-6">
                                    <div class="grid grid-cols-1 gap-4">
                                        <jet-label class="col-span-6" value="Chave"/>
                                    </div>
                                    <div class="grid grid-cols-6 col-span-6">
                                        <jet-masked-input
                                                v-if="form.newKey.key_type !== 'E-mail' && form.newKey.key_type !== 'Aleatória'"
                                                :mask="keyMask"
                                                :disabled="disabledField"
                                                type="text" class="col-span-4"
                                                v-model="form.newKey.key"/>

                                        <jet-input v-else v-model="form.newKey.key"
                                                :disabled="disabledField"
                                                placeholder="Chave"
                                                type="text"
                                                class="col-span-4"/>
                                    </div>
                                </div>
                            <jet-input-error :message="form.error('key')" class="mt-2"/>
                            </div>
                        </template>
                    </jet-form-section>

                    <jet-section-border/>

                </template>


                <confirmation-modal :show="invalidKey" @close="invalidKey=false">
                    <template #title>
                        Conta incorreta
                    </template>
                    <template #content>
                        Conta PIX inválida.
                    </template>
                    <template #footer>
                        <jet-secondary-button
                            @click.native="invalidKey=false">
                            Fechar
                        </jet-secondary-button>
                    </template>
                </confirmation-modal>

                <confirmation-modal :show="expiredCode" @close="expiredCode=false">
                    <template #title>
                        Cadastro de Chave
                    </template>
                    <template #content>
                        <div class="my-10">
                            <p>O código de confirmação expirou.</p>
                            <p>Deseja solicitar o envio de um novo código ?</p>
                        </div>
                    </template>
                    <template #footer>
                        <jet-secondary-button
                            @click.native="expiredCode=false">
                            Não
                        </jet-secondary-button>
                        <jet-ok-button class="ml-2" @click.native="expiredCode = false;form.resend = true;save();"
                                    :class="{ 'opacity-25': form.processing }"
                                    :disabled="form.processing">
                            Sim
                        </jet-ok-button>
                    </template>
                </confirmation-modal>

                <jet-confirmation-modal :show="keyVerification" @close="keyVerification=false">
                    <template #title>
                        Confirme os dados
                    </template>

                    <template #content>
                        <jet-form-section class="my-10">
                            <template #title>
                                <p>Verificar</p>
                                {{ form.newKey.key }}
                            </template>

                            <template #description>
                                Informe o código de verificação enviado para seu {{ form.newKey.key_type }}.
                            </template>

                            <template #form>
                                <div class="col-span-6 sm:col-span-6">
                                    <jet-label for="verification_code" value="Código de Confirmação"/>
                                    <jet-input id="verification_code" type="number" class="mt-1 block w-full"
                                                v-model="form.verification_code"/>
                                    <jet-input-error :message="errorCodeMsg" class="mt-2"/>
                                </div>
                            </template>
                        </jet-form-section>
                    </template>

                    <template #footer>
                        <div class="grid grid-cols-2">
                            <div class="col-span-1 text-left">
                                <jet-secondary-button :disabled="timeToResend > 0" @click.native="form.resend=true;save()">
                                    Reenviar Código <p class="ml-1" v-if="timeToResend > 0"> em {{ timeToResend}} segundos </p>
                                </jet-secondary-button>
                            </div>
                            <div class="col-span-1 items-end">
                                <jet-secondary-button @click.native="keyVerification = false">
                                    Agora não
                                </jet-secondary-button>

                                <jet-ok-button class="ml-2" @click.native="save()"
                                            :class="{ 'opacity-25': form.processing }"
                                            :disabled="form.processing">
                                    Confirmar
                                </jet-ok-button>
                            </div>
                        </div>

                    </template>
                </jet-confirmation-modal>
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from './../../Layouts/AppLayout'
import JetSectionBorder from './../../Jetstream/SectionBorder'
import JetActionMessage from "../../Jetstream/ActionMessage";
import JetButton from "../../Jetstream/Button";
import JetFormSection from "../../Jetstream/FormSection";
import JetLabel from "../../Jetstream/Label";
import JetInput from "../../Jetstream/Input";
import JetInputError from "../../Jetstream/InputError";
import JetTextarea from "../../Jetstream/Textarea";
import JetProtectedTextarea from "../../Jetstream/ProtectedTextarea";
import JetAutoComplete from "../../Jetstream/AutoComplete";
import JetConfirmationModal from "../../Jetstream/ConfirmationModal";
import JetSecondaryButton from "../../Jetstream/SecondaryButton";
import JetMaskedInput from "../../Jetstream/MaskedInput";
import Flash from "../../Helpers/Flash"
import OkButton from "../../Jetstream/OkButton";
import ConfirmationModal from "../../Jetstream/ConfirmationModal";
import JetDangerButton from "../../Jetstream/DangerButton";
import JetOkButton from "../../Jetstream/OkButton";
import _ from "lodash";

export default {
    props: ['errors', 'customer','current_verification'],
    methods: {
        save() {
            let validate = this.verifyKey();
            if (!validate.checked){
              this.$toast.open({
                    message: validate.msg,
                    type: 'error',
                    duration: 5000,
                    position: 'top-right'
                });
              return false;
            }
            this.errorCodeMsg = "";
            this.form.post(`/pix`, {
                preserveScroll: true,
                onError: (e) => {
                    this.form.processing = false;
                    this.doOnError();
                }
            });
        },
        doOnError(){            
            this.form.resend = false;
            if (this.errors.code_required){
                this.keyVerification = true;
            }else{
                if (!this.errors){
                    return false;
                }
                if (typeof this.errors.verification_code !== 'undefined') {
                    switch (this.errors.verification_code[0]) {
                        case "CODE_ERROR":
                            this.keyVerification = true;
                            this.errorCodeMsg = "O código informado está inválido.";
                            break;
                        case "CODE_EMPTY":
                            this.keyVerification = true;
                            this.errorCodeMsg = "Informe o código de verificação.";
                            break;
                        case "CODE_EXPIRED":
                            this.keyVerification = false;
                            this.expiredCode = true;
                            this.errorCodeMsg = "Código expirado";
                            break;
                        default:
                            this.errorCodeMsg = this.errors.verification_code[0];
                            this.keyVerification = true;
                            break;
                    }
                }
            }
            this.timeToResend = 0;
            if (this.current_verification){
                this.timeToResend = this.current_verification.resend_time;
            }
            this.startCounter();
            this.form.verification_code = "";
            this.$forceUpdate();
        },
        verifyKey(){
            var key = (this.form.newKey.key_type != 'E-mail' && this.form.newKey.key_type != 'Aleatória')
            ? this.form.newKey.key.replace(/\D/g,'')
            : this.form.newKey.key;

            switch (this.form.newKey.key_type) {
                case 'Celular':
                    if (key.length !== 11){
                        return { checked: false, msg: "Chave Celular inválida."}
                    }
                    return { checked: true }
                case 'E-mail':
                    if (!key.includes('@')){
                        return { checked: false, msg: "Chave E-mail inválido."}
                    }
                    return { checked: true }
                default:
                    if (key == null || key.length === 0){
                        return { checked: false, msg: "Informe a chave."}
                    }
                    return { checked: true}
            }
        },
        keyTypeByName(type){
            switch (type) {
                case 'CPF':
                    return 0;
                case 'CNPJ':
                    return 1;
                case 'Celular':
                    return 2;
                case 'E-mail':
                    return 3;
                default:
                    return 4;
            }
        },
        startCounter(){
            clearTimeout(this.timerResend);
            if (this.timeToResend > 0){
                this.timerResend = setInterval(() => {
                    if (this.timerResend <= 0){
                        startCounter();
                    }
                    this.timeToResend--;
                }, 1000);
            }
        }
    },
    watch: {
        'form.newKey.key_type': {
            handler: function (type) {
                this.disabledField = false;
                switch (type) {
                    case 'E-mail':
                        this.form.newKey.key = this.customer.email;
                        break;
                    case 'CPF':
                    case 'CNPJ':
                        this.form.newKey.key = this.customer.federal_document;
                        this.disabledField = true;
                        break;
                    case 'Celular':
                        this.form.newKey.key = this.customer.mobile_number || this.customer.phone_number;
                        break;
                    case 'Aleatória':
                        this.form.newKey.key = "Sua chave será gerada automaticamente.";
                        this.disabledField = true;
                        break;
                    default:
                        break;
                }
            },
            deep: true
        },
        errors: function (newE) {
            this.formError = newE;
        }
    },
    computed:{
        errorOp: function (){
            return this.formError;
        },
        keyMask: function(){
            switch (this.form.newKey.key_type) {
                case 'CPF':
                    return ['###.###.###-##'];
                case 'CNPJ':
                    return ['##.###.###/####-##'];
                case 'Celular':
                    return ['(##) #####-####'];
                default:
                    return [''];
            }
        }
    },
    data() {
        return {
            canSave: false,
            invalidKey:false,
            disabledField: false,
            keyVerification:false,
            expiredCode:false,
            errorCodeMsg:"",
            timeToResend:0,
            timerResend:null,
            customer_type: (this.customer.federal_document.replace(/[^0-9]/g, '').length === 14)?"CNPJ":"CPF",
            keyTypeList:[(this.customer.federal_document.replace(/[^0-9]/g, '').length === 14)?"CNPJ":"CPF",'E-mail','Celular','Aleatória'],
            form: this.$inertia.form({
                _method: 'POST',
                newKey:{
                    key:'',
                    key_type:'',
                },
                verification_code:'',
                resend:false,
                ...this.customer
            }, {
                resetOnSuccess: false,
            }),
        }
    },
    components: {
        OkButton,
        ConfirmationModal,
        AppLayout,
        Flash,
        JetAutoComplete,
        JetSectionBorder,
        JetActionMessage,
        JetButton,
        JetFormSection,
        JetInput,
        JetTextarea,
        JetProtectedTextarea,
        JetInputError,
        JetLabel,
        JetSecondaryButton,
        JetMaskedInput,
        JetConfirmationModal,
        JetDangerButton,
        JetOkButton

    }
}
</script>
